import { render } from "./Main.vue?vue&type=template&id=0e428323"
const script = {}
script.render = render

export default script